// Modules
import React from "react";
import moment from "moment";
// @ts-ignore
import { LocalizationContext } from 'react-localize';
// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";

// Styles
import "./CheckAvailabilityVillasAvailable.sass";

// Services
import ReservationService from "Services/reservation.service";
// import {LocalizationProvider} from 'react-localize';

// Interfaces
import { Tip } from "Interfaces/TipInterface";
import { DailyAvailability, MinimumPoints, WaitlistResult } from "Interfaces/ResortResultInterface";
import { RequestError, RequestErrorCode } from "Interfaces/RequestError";
import { HoldRequestData } from "Interfaces/HoldRequestData";
import { RoomModal } from "Interfaces/RoomModalInterface";
import SelectedFilters from "Interfaces/SelectedFiltersInterface";
import ContractType from "Interfaces/AdvanceSearchInterface";
import { Segment } from "Interfaces/Segment";
import { checkInDay, WaitlistData } from "Interfaces/WaitlistData";

// Components
import MvTable from "Generic/MvTable";
import ToolTip from "Generic/ToolTip"
//import MvPointsWeekCalendar from "Generic/MvPointsWeekCalendar";
import MvLoader from "Generic/MvLoader/MvLoader"
import MvModal, { MvRoomModal } from "Generic/MvModal"
import { CheckAvailabilityError } from "./CheckAvailabilityError";
import { MvSortTable } from "Generic/MvSortTable";
import { MvSortMobileTable } from "Generic/MvSortMobileTable"; //TODO: this needs to happen in CSS
import PointsCalendar from "Generic/PointsCalendar"
import Results from "Interfaces/ResultsInterface";
import VillasNotAvailable from './CheckAvailabilityVillasNotAvailable';

// Constants
import { RequestStatus } from "Constants";
import { InitRoom, InitRoomModal } from "Constants/InitInterfaces";

// Utils
import { sortVillas, SortType, SortDirection } from "Utils/SortVillas";
import { getUniqueContractSegments } from "Utils/Search"

// Other
import log, { EXEC_MODE } from "cfg";
import PointsForSearch from "./PointsForSearch";
import { ReactAppMode } from "Interfaces/ReactAppModes";
import { logAnalyticData, trackAnalyticData } from "Utils/analytics";

type Props = {
  form: any,
  propCode: any,
  selectedDate: Date | null,
  availability: any[],
  selectedResort: any,
  numNights: any,
  numGuest: any,
  selectedFilters: SelectedFilters,
  getHeldResorts(displayHeldResorts?: boolean): void;
  deleteHeldResorts(): Promise<any>;
  placeHold(holdRequestData: HoldRequestData): Promise<any>;
  goToAYP(resId: number): void;
  goToWaitlistAYP(resId: number): void;
  createWaitlist(waitlistData: WaitlistData): Promise<any>;
  waitlistToggleChecked: boolean; //This element was added to the props enable/disable available villas section
  contracts: ContractType[];
  monthlyAvailabilityData?: Results;
  loader: boolean;
  hideAvailability(): void;
  onClearSearch(): void;
  setEditingSegment(segment: Segment): void;
  editingSegment: Segment | null;
  addtoWaitilistDisabledStatus: boolean;
  sessionId: any;
  checkInDays: checkInDay[];
  apiTimeout: string;
};

enum ModalTypes {
  ROOM_MODAL = "room_modal",
};

/*This enum was added because backend added a flag called availability in the daily availability response.
Based on the flag, the FE will display the rooms or an error message
1. available => rooms will be shown
2. unavailable or n/a => unavailable error message will be shown
3. unaffordable => unaffordable message will be shown
*/
export enum AvailabilityFlag {
  AVAILABLE = "AVAILABLE",
  UNAVAILABLE = "UNAVAILABLE",
  UNAFFORDABLE = "UNAFFORDABLE",
  NA = "N/A",
};

type State = {
  singleRoomInfo: any,
  roomsAvailable: DailyAvailability[],
  roomsUnavailable: WaitlistResult[],
  roomType: string,
  roomPoints: string,
  buttonClicked: boolean,
  holdDisabled: boolean,
  progressCursor: boolean,
  dailyRequestStatus: RequestStatus,
  minNightsError: {
    show: boolean,
    minNights: null | number | string
  },
  [ModalTypes.ROOM_MODAL]: RoomModal,
  selectedRoom: DailyAvailability,
  tableSortStates: {
    [SortType.ROOM]: SortDirection,
    [SortType.VIEW]: SortDirection,
    [SortType.POINTS]: SortDirection,
    [SortType.ADJUSTMENTS]: SortDirection,
  },
  roomsSortOrder: any,
  fetchLoaded: boolean,
  waitlistOptionsForVillasNotAvailable: boolean //This element was added to the props enable/disable available villas section
  isMobile: boolean //TODO: need to handle this in CSS
  currentPointsBalance: number;
  potentialPointBalance: number;
  availableFlag: AvailabilityFlag; //Flag for showing rooms or error message in availability table
  disableVoaBookCapability: boolean; //MVC-228 flag to disable action buttons - continue, hold & browse, waitlist add, back end is giving this
};

const InitState: State = {
  roomsAvailable: [],
  roomsUnavailable: [],
  singleRoomInfo: {},
  roomType: "",
  roomPoints: "",
  buttonClicked: false,
  holdDisabled: true,
  progressCursor: false,
  dailyRequestStatus: RequestStatus.LOADING,
  minNightsError: {
    show: false,
    minNights: null
  },
  [ModalTypes.ROOM_MODAL]: Object.assign(InitRoomModal, {}),
  selectedRoom: Object.assign(InitRoom, {}),
  tableSortStates: {
    [SortType.ROOM]: SortDirection.ASC,
    [SortType.VIEW]: SortDirection.ASC,
    [SortType.POINTS]: SortDirection.ASC,
    [SortType.ADJUSTMENTS]: SortDirection.ASC,
  },
  roomsSortOrder: {},
  fetchLoaded: false,
  waitlistOptionsForVillasNotAvailable: false,
  isMobile: false,
  currentPointsBalance: 0,
  potentialPointBalance: 0,
  availableFlag: AvailabilityFlag.AVAILABLE,
  disableVoaBookCapability: false
};

class CheckAvailabilityVillasAvailable extends React.Component<Props, State> {
  reservationService: ReservationService;
  _isMounted: boolean;
  cursorWaitStyle = {
    cursor: "wait"
  };
  cursorNormalStyle = {
    cursor: "default"
  }

  //villas unavailable component will set this to a method in it's component and pass to this component through props
  // deselectWaitlistOptions: any;
  deselectWaitlistOptions = () => { };

  constructor(props: any) {
    super(props);
    this.reservationService = new ReservationService();
    this.toggleModal = this.toggleModal.bind(this);
    this.placeHold = this.placeHold.bind(this);
    this.continueToAYP = this.continueToAYP.bind(this);
    this.onSortClicked = this.onSortClicked.bind(this);
    this._isMounted = false;
    this.state = {
      ...InitState
    }
  }

  adjustmentTip: [Tip] = [
    {
      label: "",
      desc: "+ Premium Adjustment: It is necessary for owners who have not achieved a Benefit Level to use additional points in order to confirm a reservation more than 12-months in advance. - Discounts: You have selected a vacation during a time frame that qualifies for a discount."
    }
  ];

  /**
   * 
   * @param nextProps 
   * This react lifecycle method will only be called after the initial rendering of the elements in JSX, not during the initial render.
   * Every time props is passed to this class component, we check if certain elements in prop has changed and based on that we decide to set state and re-render
   * If the user has selected a date in the calendar view, holdDisabled wil be set to true, since we don't want to enable the actionButtons() until the user has selected a room in the vllasTable()
   * This method also will be called everysingle time the user has changed the date in the calendar view or wait list toggle is changed.
   */
  componentWillReceiveProps(nextProps: any) {
    const roomFiltersChanged = this.props.selectedFilters.roomType.filters.length !==
      nextProps.selectedFilters.roomType.filters.length;
    const viewFiltersChanged = this.props.selectedFilters.views.filters.length !==
      nextProps.selectedFilters.views.filters.length;

    const waitlistToggleChanged = this.props.waitlistToggleChecked !== nextProps.waitlistToggleChecked;

    if (nextProps.selectedDate != this.props.selectedDate ||
      roomFiltersChanged || viewFiltersChanged) {
      this.setState({
        roomsAvailable: [],
        roomsUnavailable: [],
        currentPointsBalance: 0,
        potentialPointBalance: 0,
        selectedRoom: Object.assign(InitRoom, {}),
        holdDisabled: true,
        dailyRequestStatus: RequestStatus.LOADING,
        availableFlag: AvailabilityFlag.AVAILABLE
      }, () => {
        this.fetchDailyAvailability(nextProps.selectedDate);
      });
    }

    if (waitlistToggleChanged) {
      this.setState({
        waitlistOptionsForVillasNotAvailable: nextProps.waitlistToggleChecked
      })
    }
  }

  componentDidMount(): void {
    this._isMounted = true;

    if (this.props.selectedDate)
      this.fetchDailyAvailability(this.props.selectedDate)
    this.setState({
      isMobile: window.screen.width <= 480,
    });
    window.onresize = () => {
      if (window.screen.width <= 480 && !this.state.isMobile) {
        this.setState({
          isMobile: true,
        });
      }
      else if (window.screen.width > 480 && this.state.isMobile) {
        this.setState({
          isMobile: false,
        });
      }
    }
  }

  componentWillUnmount(): void {
    this._isMounted = false;
  }

  /**
   * Filter out empty rooms from dailyresults
   */
  filterDailyResults(dailyresults: DailyAvailability[]) {
    return dailyresults.filter(room => room.daily.length > 0);
  }

  /**
   * Filter out empty rooms from dailyresults
   */
  filterWaitlistResults(waitlistresults: WaitlistResult[]) {
    return waitlistresults.filter(room => room.daily.length > 0);
  }

  /**
   * The daily results are sorted by room type, smallest to largest.
   * get that sort order for future use.
   */
  getRoomSortOrder(dailyresults: DailyAvailability[]) {
    const roomsSortOrder: { [key: string]: number } = {};

    dailyresults.forEach((villa: DailyAvailability) => {
      if (roomsSortOrder[villa.room] === undefined) {
        roomsSortOrder[villa.room] = Object.keys(roomsSortOrder).length;
      }
    });

    return roomsSortOrder;
  }

  fetchDailyAvailability(selectedDate: Date): void {

    //this either needs to be a method in props and called in CheckAvailabilityresultItem and results passed here and to CheckAvailabilityVillasNotAvailable
    // OR we need to have this call a method in props to pass back the results
    // OR move CheckAvailabilityVillasNotAvailable component to this components render method - TRY THIS ONE 1ST !!!!

    this.setState({ dailyRequestStatus: RequestStatus.LOADING });

    const checkIn: string = moment(selectedDate).format("DD MMM YYYY");
    let updatedForm = this.props.form
    updatedForm = {
      ...this.props.form,
      centralRoomTypeCode: this.props.selectedFilters.roomType.filters,
      viewCode: this.props.selectedFilters.views.filters,
    }
    const segments = getUniqueContractSegments(updatedForm);
    this.reservationService.searchDailyAvailability(this.props.propCode, checkIn, updatedForm, segments)
      .then(res => {
        const roomsAvailable = this.filterDailyResults(res.dailyresults)
        const roomsUnavailable = this.filterWaitlistResults(res.waitlistresults);
        const roomsSortOrder = this.getRoomSortOrder(roomsAvailable);

        this.setState({
          roomsAvailable,
          roomsUnavailable,
          roomsSortOrder,
          currentPointsBalance: res.points ? res.points.mppDay[0].mppSegment.cfpv : 0,
          potentialPointBalance: res.points ? res.points.mppDay[0].mppSegment.maxpp : 0,
          dailyRequestStatus: RequestStatus.LOADED,
          minNightsError: {
            show: false,
            minNights: null,
          },
          availableFlag: res.availability!,
          disableVoaBookCapability: res.disableVoaBookCapability || false //MVC-228 flag to disable action buttons - continue, hold & browse, waitlist add, back end is giving this
        })
      }).catch((error: any) => {
        log.error(`searchDailyAvailability Error: ${JSON.stringify(error)}`);
        const { errorCode, message, errorObject } = error;

        if (this._isMounted) {
          // Minimum nights error
          if (errorCode === "MINIMUM_NIGHTS_VALIDATION_ERROR" &&
            errorObject && errorObject.minimumNights) {
            this.setState({
              minNightsError: {
                show: true,
                minNights: errorObject.minimumNights,
              },
              dailyRequestStatus: RequestStatus.LOADED,
            })
          }
        }
      });

  }


  fetchFloorPlan(roomParams: any) {
    this.reservationService.searchRoomInfo(roomParams).then(res => {
      this.setState({ singleRoomInfo: res })
      this.setState({ fetchLoaded: true })
    })
  }

  //if at least 1 'View' value exists return true
  checkViewColumn(): boolean {
    let displayViews = false
    this.state.roomsAvailable.forEach((villa: any) => {
      if (villa.viewDescription != '') {
        displayViews = true;
      }
    })
    return displayViews
  }

  //if at least 1 'Adjustment' value exists return true
  checkAdjustmentsColumn(): boolean {
    let displayAdjustments = false;
    this.state.roomsAvailable.forEach((villa: any) => {
      if (villa.daily.length > 0 && (Number(villa.daily[0].adjustments)) !== 0) {
        displayAdjustments = true
      }
    })
    return displayAdjustments
  }

  adjustmentsJSX = () => {
    const { localize } = this.context;

    return (
      <div className="adjustments-container">
        <span>{localize("static.content.adjustments")}</span>

        <div className='tool-tip-vc tool-tip-trigger'>
          <div className="adjustments-tooltip">

            <ToolTip useRefToPosition={false} tabIndex={0} tip={this.adjustmentTip} id='adjustments-col'>
              <span className="question-icon">{"?"}</span>
            </ToolTip>
          </div>
        </div>
      </div>
    );
  };

  //returns column headers for MvTable
  getHeaders(): any[] {
    const { localize } = this.context;

    const showViewColumn = this.checkViewColumn();
    const showAdjustmentsColumn = this.checkAdjustmentsColumn();

    let headers = [
      // room type column
      {
        text: localize("static.content.room-type"),
        // (
        //   <span className="room-type-header">
        //     {localize("static.content.room-type")}
        //   </span>
        // ),
        sortable: true,
        curSortDirection: this.state.tableSortStates[SortType.ROOM],
        onSort: () => {
          this.onSortClicked(SortType.ROOM);
        }
      },
    ];

    // view column
    if (showViewColumn) {
      headers.push(
        {
          text: localize("static.content.view"),
          sortable: true,
          curSortDirection: this.state.tableSortStates[SortType.VIEW],
          onSort: () => {
            this.onSortClicked(SortType.VIEW);
          }
        }
      );
    }

    // total points column
    headers.push(
      {
        text: localize("static.content.total-points-needed"),
        sortable: true,
        curSortDirection: this.state.tableSortStates[SortType.POINTS],
        onSort: () => {
          this.onSortClicked(SortType.POINTS);
        }
      }
    );

    // adjustments column
    if (showAdjustmentsColumn) {
      const columnHeader = this.adjustmentsJSX();

      headers.push(
        {
          text: columnHeader,
          sortable: true,
          curSortDirection: this.state.tableSortStates[SortType.ADJUSTMENTS],
          onSort: () => {
            this.onSortClicked(SortType.ADJUSTMENTS);
          }
        }
      );
    }

    return headers;
  }

  /**
   * return the jsx for each row and cell in the 'Villas' table
   */
  getRows() {
    const { localize } = this.context;

    const showViewColumn = this.checkViewColumn();
    const showAdjustmentsColumn = this.checkAdjustmentsColumn();
    const segments = JSON.parse(sessionStorage.read(ReservationService.SEGMENTS));

    console.log("ROOMS AVAILABLE =>>>>>>>>>>>>>>>>" + JSON.stringify(this.state.roomsAvailable));

    return this.state.roomsAvailable.map((villa: any) => {
      const handleModal = () => {
        this.fetchFloorPlan({
          segments: segments || ["PTS", "INA", "AP2"],
          resorts: [this.props.propCode],
          codeRoomPoolCode: [villa.roomPoolCode]
        })
        this.setState({
          [ModalTypes.ROOM_MODAL]: {
            ...this.state[ModalTypes.ROOM_MODAL],
            room: villa,
            show: true,
          },
          // selectedRoom: villa
        })
      }

      const totalPointsNeeded = villa.pointAmount;
      const adjustments = villa.totaladjustedPoints;

      let trimmedRoomTypeLabel = (
        <>
          {villa.roomTypeLabel}
        </>
      );

      const parenthIndex = villa.roomTypeLabel.indexOf('(');

      if (villa.roomTypeLabel > 32 && parenthIndex !== -1) {
        trimmedRoomTypeLabel = (
          <>
            {villa.roomTypeLabel.slice(0, parenthIndex)}
            <br />
            {villa.roomTypeLabel.slice(parenthIndex)}
          </>
        );
      }

      const rowCells: any = {
        room: (
          <div style={{
            display: 'flex',
            alignItems: 'flex-start'
          }}>
            <input
              name='room-radio'
              onClick={() => this.onRoomSelect(villa)}
              className="room-input" type="radio"
              checked={(this.state.selectedRoom.roomPoolCode === villa.roomPoolCode) ? true : false}
            />

            <button className="room-link" onClick={handleModal}>
              <span>{trimmedRoomTypeLabel}</span>
            </button>
          </div>
        ),
      };
      if (showViewColumn) {
        if (!this.state.isMobile) {
          rowCells.View = (<div className="view-container"><span>{villa.viewDescription}</span></div>)
        } else {
          rowCells.View = (<><span>{villa.viewDescription}</span></>)
        }
      }
      rowCells[' Total Points Needed'] = (<><span>{totalPointsNeeded}</span></>);

      if (showAdjustmentsColumn) {
        rowCells.Adjustments = (<><span>{adjustments}</span></>);
      }

      return {
        rowKey: villa.roomPoolCode,
        rowCells,
        rowExpanded: (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div className="point-calendar-container">
              <PointsCalendar
                startDate={moment(this.props.selectedDate as Date).format("MM/01/YYYY")}
                data={villa.daily}
                activeDate={null}
              />
            </div>
          </div>
        )
      }
    });
  }

  /**
   * fired when a room is selected from the villas table
   *
   * set the selected room in state, and enable the "Hold & Browse" and
   * "Continue" buttons
   */
  onRoomSelect(selectedRoom: DailyAvailability) {
    this.setState({
      holdDisabled: false,
      selectedRoom,
    });

    //need to call method on villas unavailable to disable waitlist button and de-select items
    this.deselectWaitlistOptions();

  }

  onWaitlistRoomSelect = (selected: boolean) => {
    if (selected) {
      this.setState({
        holdDisabled: true,
        selectedRoom: Object.assign(InitRoom, {}),
      });
    }
  }

  /**
 * toggle a modal of a given type
 */
  toggleModal(modalType: ModalTypes): void {
    if (this.state[modalType].show == true) {
      this.setState({ fetchLoaded: false })
      console.log('(*(&&^%^&*(')
    }
    this.setState({
      [modalType]: {
        ...this.state[modalType],
        show: !this.state[modalType].show
      },
    } as any);
  }

  /**
   * find and replace all anchor tags
   * 
   * anchor will have the following format:
   *      {​​<A}​​booking window|/inventoryreleasecalendar.jsp{A>}
   *      The left side of pipe is the text to render
   *      The right side of pipe is the relative url
   */
  fNRAnchors = (text: string): JSX.Element[] => {
    const openTag = '{<A}';
    const closeTag = '{A>}';
    const regex = /({<A}.*?{A>})/;

    const returnJsx: JSX.Element[] = [];

    if (text.indexOf(openTag) === -1) {
      return [<>{text}</>];
    };

    // use regex to split text into text and anchor segments
    const parts = text.split(regex);

    for (let part of parts) {
      // isn't an anchor segment
      if (part.indexOf(openTag) === -1) {
        returnJsx.push(<span key={part}>{part}</span>);
      } else {
        // remove outer delimiting tags
        part = part.replace(openTag, '');
        part = part.replace(closeTag, '');

        // split into text and url text
        const [text, urlText] = part.split('|');
        // push <a> element to return Jsx
        returnJsx.push(
          <span className='jahia-anchor-text' key={urlText}>
            {([ReactAppMode.VCAP].includes(EXEC_MODE)) ? (
              <a href={urlText}>{text}</a>
            ) : (
              <a href='/timeshare/mvco/ownerresources/inventorycalendar'>{text}</a>
            )}
          </span>
        );
      }
    }
    return returnJsx;
  };

  /**
   * Check for availability errors and return error message
   */
  checkForAvailabilityErrors(): JSX.Element[] {
    let errors: JSX.Element[] = [];
    const { localize } = this.context;

    if (this.state.minNightsError.show) {
      // get content from check-availability-min-nights-error, replace {</minNumberNights>} and replace anchor tags
      let errorMessage = localize("static.content.check-availability-min-nights-error");
      errorMessage = errorMessage.replace('{</minNumberNights>}', this.state.minNightsError.minNights)
      errors = this.fNRAnchors(errorMessage);
    } else if (this.state.dailyRequestStatus === RequestStatus.LOADED && (this.state.availableFlag === AvailabilityFlag.UNAVAILABLE
      || this.state.availableFlag === AvailabilityFlag.NA)) {
      errors = [<>{localize("static.content.villa-unavailable")}</>];
    } else if (this.state.dailyRequestStatus === RequestStatus.LOADED && this.state.availableFlag === AvailabilityFlag.UNAFFORDABLE) {
      errors = [<>{localize("static.content.villa-affordability")}</>];
    }

    // else if (this.state.dailyRequestStatus === RequestStatus.LOADED && this.state.roomsAvailable.length === 0) {
    //   //if no availability returned on daily check, assumption is the reason would be no affordability
    //   errors = [<>{localize("static.content.villa-affordability")}</>];
    // }

    return errors;
  }

  /**
   * Check for affordability errors and return error message
   */
  checkForAffordabilityError(): JSX.Element[] {
    let errorMessage: JSX.Element[] = [];

    if (this.state.dailyRequestStatus !== RequestStatus.LOADED) {
      return errorMessage;
    }

    const { localize } = this.context;
    let isError = true
    const roomsAvailable = this.state.roomsAvailable || []
    roomsAvailable.forEach(roomDetail => {
      if (roomDetail.daily && roomDetail.daily.length > 0 && roomDetail.daily[0].daily && roomDetail.daily[0].daily.length > 0) {
        isError = false
      }
    });

    if (isError) {
      errorMessage = [<>{localize("static.content.villa-affordability")}</>]
    }
    return errorMessage;
  }

  /**
   * fired when the 'Continue' btn is clicked
   *
   * Deletes all holds, then attempts to place a hold on the
   * currently selected room. If successful, route to 'Apply your Points' page
   */
  continueToAYP() {
    this.setState({ holdDisabled: true, progressCursor: true })
    
    logAnalyticData({ event: 'Continue to AYP', siteSection: '', pageName:'Book My Holiday', website:'' }, {
      ownerActivity: '',
      step:'Step 3 – Continue Booking',
      errorMessagfe:"",
      notificationType: "",
      customerID:"",
      searchCheckInDate: "",    
    })
    trackAnalyticData('Points Booking - Step 3 – Continue Booking');

    // Delete all current holds
    this.props.deleteHeldResorts()
      .then((deleteResult) => {
        this.placeHold().then((holdResult) => {

          const resId = holdResult.ReservedInventoryIds[0];
          this.props.goToAYP(resId);
          this.setState({ holdDisabled: false, progressCursor: false })
        }).catch((error: RequestError) => {
          this.setState({ holdDisabled: false, progressCursor: false })
          // Error is handled in placeHold function in book-my-holiday
        });;
      });
  }

  cancel() {
    this.props.hideAvailability();
    this.props.onClearSearch();
  }

  /**
   * attempt to place a hold on a reservation
   */
  placeHold(): Promise<any> {
    this.setState({ holdDisabled: true, progressCursor: true })

    return new Promise((resolve, reject) => {
      const { form, selectedDate, propCode } = this.props;
      const { selectedRoom } = this.state;
      const holdRequestData: HoldRequestData = {
        resortCode: propCode,
        checkIn: selectedDate as Date,
        marshaRateCode: selectedRoom.rateCode,
        numOfGuests: form.numGuests,
        numOfNights: form.numNights,
        accessibility: form.accessibility ? [form.accessibility] : [],
        hearingaccessible: form.hearing,
        roomPoolCode: [selectedRoom.roomPoolCode],
        dailyresults: selectedRoom,
        contracts: form.contractDetails.filter((x: any) => form.contracts.includes(x.id)).map((x: any) => ({ contractId: x.id, reservationTypeName: x.reservationTypeName, reservationTypeId: x.reservationTypeId }))
      }

      // Attempt to place hold on selectedRoom
      this.props.placeHold(holdRequestData).then((holdResult) => {
        resolve(holdResult);
        this.setState({ holdDisabled: false, progressCursor: false })
        /**
         * PWAS Analytics on Hold and Browse
         */
        logAnalyticData({ event: 'Hold and Browse', siteSection: '', pageName:'Book My Holiday', website:'' }, {
        ownerActivity: '',
        step:'Points Booking - Step 3 – Hold & Browse',
        errorMessagfe:"",
        notificationType: "",
        customerID:"",
        searchCheckInDate: "",    
      })
      
      trackAnalyticData('Points Booking - Step 3 – Hold & Browse');

      }).catch((error: RequestError) => {
        // If the hold failed due to no availability, refresh daily availability
        if (error.errorCode === RequestErrorCode.NO_TSW_AVAILABILITY) {
          this.fetchDailyAvailability(this.props.selectedDate as Date)
          this.setState({ holdDisabled: false, progressCursor: false })
        }
        reject(error);
        this.setState({ holdDisabled: false, progressCursor: false })
      });
    })

  }

  /**
   * fired when a column sort icon is clicked in the 'Villas' table
   */
  onSortClicked(sortField: SortType) {
    const villas = [...this.state.roomsAvailable];
    const sortDirection = this.state.tableSortStates[sortField] === SortDirection.ASC ?
      SortDirection.DESC : SortDirection.ASC;

    const sortedVillas = sortVillas(
      this.state.roomsSortOrder,
      villas,
      sortField,
      sortDirection
    );

    const tableSortStates = { ...this.state.tableSortStates };

    // update the sort direction of the sort field that was clicked
    tableSortStates[sortField] = sortDirection;

    // reset other sort directions to ASC (all sort icons will return to ASC)
    if (sortField !== SortType.ROOM) {
      tableSortStates[SortType.ROOM] = SortDirection.ASC;
    }
    if (sortField !== SortType.VIEW) {
      tableSortStates[SortType.VIEW] = SortDirection.ASC;
    }
    if (sortField !== SortType.POINTS) {
      tableSortStates[SortType.POINTS] = SortDirection.ASC;
    }
    if (sortField !== SortType.ADJUSTMENTS) {
      tableSortStates[SortType.ADJUSTMENTS] = SortDirection.ASC;
    }

    this.setState({
      roomsAvailable: sortedVillas,
      tableSortStates,
    });
  }

  /**
   * Render the villas table or availability errors, if present
   */
  villasTable() {
    const availabilityErrors = this.checkForAvailabilityErrors();
    if (availabilityErrors.length > 0) {
      return (
        <CheckAvailabilityError
          message={availabilityErrors}
        />)
    }

    /*
      with the recent change to display the affordability error when no availability is
      returned in the daily availability check, this check will never run, however,
      leaving it here in the event the backend logic changes to return availability, but
      returns no daily points
    */
    const affordabilityError = this.checkForAffordabilityError();
    if (affordabilityError.length > 0) {
      return <CheckAvailabilityError
        message={affordabilityError}
      />
    }

    let tableRows, dataStatus, rowsExpandable = true;
    dataStatus = this.state.dailyRequestStatus;

    if (this.props.selectedDate) {
      tableRows = this.getRows();
    }
    else {
      rowsExpandable = false;
      if (this.props.loader) dataStatus = RequestStatus.LOADING;
      else dataStatus = undefined
      if (!this.props.monthlyAvailabilityData || !this.props.monthlyAvailabilityData.monthlyresults.length) {
        tableRows = [{
          rowKey: 'villas-not-available',
          rowCells: {
            room: <i>We're sorry, there is no availability</i>,
          },
        }];
      }
      else {
        tableRows = [{
          rowKey: 'select-date',
          rowCells: {
            room: <i>Please select a date</i>,
          },
        }];
      }
    }
    if (this.state.isMobile) {
      const tableHeaders = [this.getHeaders()[0]];
      return (
        <MvSortMobileTable
          rowKey="roomPoolCode"
          headers={tableHeaders}
          rows={tableRows}
          dataStatus={dataStatus as RequestStatus}
          headerSection={null}
          rowsExpandable={rowsExpandable}
          minWidth={tableHeaders.length * 230}
          columnStyles={{
            0: { // room-type column
              minWidth: "250px",
            },
          }}
        />
      );
    }
    else {
      const tableHeaders = this.getHeaders();
      return (
        <MvSortTable
          rowKey="roomPoolCode"
          headers={tableHeaders}
          rows={tableRows}
          dataStatus={dataStatus as RequestStatus}
          headerSection={null}
          rowsExpandable={rowsExpandable}
          minWidth={0}
          columnStyles={{
            0: { // room-type column
              minWidth: "250px",
            },
          }}
          apiTimeout={this.props.apiTimeout}
        />
      );
    }
  }

  /**
   * Render action buttons
   */
  actionsButtons() {
    const { localize } = this.context;

    return (
      <div className="villa-options" style={this.state.progressCursor ? this.cursorWaitStyle : this.cursorNormalStyle}>
        <button
          disabled={this.state.holdDisabled}
          className={this.state.holdDisabled ? "mv-button primary disabled" : "mv-button primary"}
          onClick={this.placeHold}
        >
          <span className="search-carat">{localize("static.content.hold-and-browse")}</span>
        </button>
        <button
          disabled={this.state.holdDisabled}
          onClick={this.continueToAYP}
          className={this.state.holdDisabled ? "mv-button primary disabled" : "mv-button primary"}
        >
          <span className="search-carat">{localize("static.content.continue")}</span>
        </button>
      </div>
    );
  }


  render(): React.ReactNode {
    let checkIn: string;

    if (this.props.selectedDate)
      checkIn = moment(this.props.selectedDate as Date).format("DD MMM YYYY");
    else {
      const { startDate, flexibleSearch } = this.props.form;
      if (flexibleSearch) {
        checkIn = moment(startDate).format("MMM YYYY");
      }
      else {
        checkIn = moment(startDate).format("DD MMM YYYY");
      }
    }

    const { localize } = this.context;

    return (
      <>
        <MvRoomModal
          toggle={() => this.toggleModal(ModalTypes.ROOM_MODAL)}
          data={{ ...this.state[ModalTypes.ROOM_MODAL], ...this.state.singleRoomInfo[0] }}
          fetchLoaded={this.state.fetchLoaded}
        />
        {<PointsForSearch
            selectedDate={this.props.selectedDate as Date}
            currentBalance={`${this.state.currentPointsBalance}`}
            potentialBalance={`${this.state.potentialPointBalance}`}
        /> }
        <div className="villa-section">
          <div className="villa-availability">
            <p className="check-in-date">
              <span className='villas-avail'>Villas Available for: </span>
              <span>{checkIn}</span>
              <span><i> (Select Room Type Below) </i></span>
              {/* <span>
                {
                  this.props.waitlistToggleChecked ? '| To enable this section, disable the waitlist Options section' : ''
                }
              </span> */}
            </p>
            {/* <div className={`available-rooms-table ${this.props.waitlistToggleChecked ? 'disabled' : ''}`}> */}
            <div className={`available-rooms-table`}>
              {this.villasTable()}
            </div>
            {/* {!this.props.waitlistToggleChecked && */}
            {
              !this.state.disableVoaBookCapability && this.actionsButtons() //MVC-228, conditionally render action buttons based on flag from BE daily availabiltiy api call
            }
          </div>
        </div>
        {/* {this.props.selectedDate && this.state.roomsUnavailable.length > 0 && 
          <VillasNotAvailable
              roomsUnavailable={this.state.roomsUnavailable}
              rangeStartDate={moment(this.props.selectedDate).format("YYYY-MM-DD")}
              rangeEndDate={moment(this.props.selectedDate).format("YYYY-MM-DD")}
              addtoWaitilistDisabledStatus={this.props.addtoWaitilistDisabledStatus}
              hideAvailability={this.props.hideAvailability}
              onClearSearch={this.props.onClearSearch}
              selectedFilters={this.props.selectedFilters}
              selectedDate={moment(this.props.selectedDate).toDate()}
              // availability={[]}
              propCode={this.props.propCode}
              form={this.props.form}
              selectedResort={this.props.selectedResort}
              numNights={this.props.form.numNights}
              numGuest={this.props.form.numNights}
              // goToAYP={this.props.goToAYP}
              goToWaitlistAYP={this.props.goToWaitlistAYP}
              // getHeldResorts={this.props.getHeldResorts}
              // deleteHeldResorts={this.props.deleteHeldResorts}
              // placeHold={this.props.placeHold}
              createWaitlist={this.props.createWaitlist}
              waitlistToggleChecked={true}//always true or only if unavailableresults? {this.state.waitlistOptionsForVillasNotAvailable}
              setEditingSegment={this.props.setEditingSegment}
              editingSegment={this.props.editingSegment}
              sessionId={this.props.sessionId}
              checkInDays={this.props.checkInDays}
              maxPpe={this.state.potentialPointBalance}
              setDeselectWaitlistOptions={(deselect: any) => this.deselectWaitlistOptions = deselect}
              onWaitlistRoomSelect={this.onWaitlistRoomSelect}
          />
      } */}
      </>
    )
  }
}

CheckAvailabilityVillasAvailable.contextType = LocalizationContext;
export default CheckAvailabilityVillasAvailable;
